import React, { useState, useEffect } from "react";
import classnames from "classnames/bind";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import dayjs from "dayjs";

import { getImage } from "src/utils/Firebase";
import { setBoardId } from "src/redux/board/actions";
import avatarImg from "../assets/Main.jpeg";

import css from "./BoardContent.scss";

const cx = classnames.bind(css);
const moduleName = "BoardContent";

const BoardContent = ({ boardId, title, content, date, imgUrl: imgUrlProp, setBoardId }) => {
  const [imgUrl, setImgUrl] = useState(imgUrlProp || "");

  useEffect(() => {
    // DB에 imgUrl이 이미 있으면 Storage 재요청 안함
    if (imgUrl) return;
    getImage()
      .child(`/board${boardId}.jpg`)
      .getDownloadURL()
      .then((url) => setImgUrl(url))
      .catch(() =>
        getImage()
          .child(`/board${boardId}.jpeg`)
          .getDownloadURL()
          .then((url) => setImgUrl(url))
          .catch(() => {})
      );
  }, [boardId]);

  const formattedDate = date ? dayjs(date).format("YYYY년 MM월 DD일") : "";
  const preview = content ? content.slice(0, 80) + (content.length > 80 ? "…" : "") : "";

  return (
    <div className={cx(moduleName)}>
      {/* 상단 프로필 */}
      <div className={cx(`${moduleName}-header`)}>
        <img src={avatarImg} alt="avatar" className={cx(`${moduleName}-avatar`)} />
        <div className={cx(`${moduleName}-header-info`)}>
          <span className={cx(`${moduleName}-username`)}>스테이 무릉도원</span>
          <span className={cx(`${moduleName}-location`)}>강원도 영월군</span>
        </div>
      </div>

      {/* 이미지 */}
      <Link
        to={`/board/${boardId}`}
        className={cx(`${moduleName}-img-wrap`)}
        onClick={() => setBoardId({ selectedId: boardId })}
      >
        {imgUrl ? (
          <img src={imgUrl} alt={title} className={cx(`${moduleName}-img`)} />
        ) : (
          <div className={cx(`${moduleName}-placeholder`)} />
        )}
      </Link>

      {/* 하단 캡션 영역 */}
      <div className={cx(`${moduleName}-body`)}>
        <p className={cx(`${moduleName}-date`)}>{formattedDate}</p>
        <p className={cx(`${moduleName}-caption`)}>
          <span className={cx(`${moduleName}-caption-name`)}>스테이 무릉도원</span>
          {" "}{preview}
        </p>
        <Link
          to={`/board/${boardId}`}
          className={cx(`${moduleName}-more`)}
          onClick={() => setBoardId({ selectedId: boardId })}
        >
          더 보기
        </Link>
      </div>
    </div>
  );
};

export default connect(
  ({ board }) => ({ board }),
  { setBoardId }
)(BoardContent);



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Boards/components/BoardContent.js